import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { UdBreadcrumb } from "../components/UdBreadcrumb";
import { UdExplainer } from "../components/UdExplainer";
import { UuidTool } from "../components/UuidTool";

export function UuidInspectorPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <UdBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.ud_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.ud_intro()}
          </p>
        </header>

        <UuidTool />

        <UdExplainer
          howTo={m.ud_howto()}
          faqs={[
            { q: m.ud_faq1_q(), a: m.ud_faq1_a() },
            { q: m.ud_faq2_q(), a: m.ud_faq2_a() },
            { q: m.ud_faq3_q(), a: m.ud_faq3_a() },
            { q: m.ud_faq4_q(), a: m.ud_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
